import { ProductDTO } from './ProductDTO';

export class ChildProductDTO {
  constructor(
    public productRelationshipId: number | undefined,
    public childProduct: ProductDTO,
    public id?: number,
  ) {}
}
